import { Theme } from '@material-ui/core';

export const getToolbarButtonStyle = (theme: Theme) => ({
  backgroundColor: 'transparent',
  color: theme.color.grey.neutral300,
  border: '1px solid #D9D9D9',
  borderRadius: 4,
  padding: '4.5px 12px',
  fontSize: '12px',
  fontWeight: 600,
  textTransform: 'none' as const,
  minWidth: 'auto',
});

export const BUTTON_ICON_STYLE = { fontSize: 14 };

export const getPrimaryButtonStyle = (theme: Theme) => ({
  ...getToolbarButtonStyle(theme),
  backgroundColor: theme.palette.primary.main,
  borderColor: theme.palette.primary.main,
  color: '#ffffff',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
    borderColor: theme.palette.primary.dark,
  },
  '&.Mui-disabled': {
    color: '#ffffff',
    opacity: 0.45,
  },
});
